import React, { useEffect, useState } from 'react';
import { fetchHeadings, fetchMaterials, addFormula } from '../../services/materialCalculatorAPI';

const AddFormula = () => {
  const [headings, setHeadings] = useState([]);
  const [materials, setMaterials] = useState([]);
  const [headingId, setHeadingId] = useState('');
  const [materialId, setMaterialId] = useState('');
  const [baseQuantity, setBaseQuantity] = useState('');
  const [materialQuantity, setMaterialQuantity] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    // Fetch Work Headings
    fetchHeadings()
      .then((data) => {
        console.log("🔍 Headings response:", data);
        const items = Array.isArray(data) ? data : data.headings || [];
        setHeadings(items);
      })
      .catch((err) => console.error("Error fetching headings", err));

    // Fetch Materials
    fetchMaterials()
      .then((data) => {
        console.log("🔍 Materials response:", data);
        const items = Array.isArray(data) ? data : data.materials || [];
        setMaterials(items);
      })
      .catch((err) => console.error("Error fetching materials", err));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!headingId || !materialId || !baseQuantity || !materialQuantity) {
      setMessage("All fields are required");
      return;
    }

    const response = await addFormula({
      heading_id: headingId,
      material_id: materialId,
      base_quantity: parseFloat(baseQuantity),
      material_quantity: parseFloat(materialQuantity),
    });

    setMessage(response.message || (response.success ? "Formula added successfully" : "Failed to add formula"));

    if (response.success) {
      setBaseQuantity('');
      setMaterialQuantity('');
    }
  };

  return (
    <div className="p-4 max-w-md mx-auto border rounded shadow bg-white">
      <h2 className="text-lg font-bold mb-4 text-center">➕ Add Formula (Heading ➝ Material)</h2>

      <form onSubmit={handleSubmit} className="space-y-3">
        {/* Work Heading Dropdown */}
        <select
          className="w-full border p-2 rounded"
          value={headingId}
          onChange={(e) => setHeadingId(e.target.value)}
          required
        >
          <option value="">Select Work Heading</option>
          {headings.map((h) => (
            <option key={h.id} value={h.id}>
              {h.name} ({h.unit})
            </option>
          ))}
        </select>

        {/* Material Dropdown */}
        <select
          className="w-full border p-2 rounded"
          value={materialId}
          onChange={(e) => setMaterialId(e.target.value)}
          required
        >
          <option value="">Select Material</option>
          {materials.map((m) => (
            <option key={m.id} value={m.id}>
              {m.name} ({m.unit})
            </option>
          ))}
        </select>

        {/* Base Quantity */}
        <input
          type="number"
          step="0.01"
          className="w-full border p-2 rounded"
          placeholder="Base Quantity (e.g., 13 sqm)"
          value={baseQuantity}
          onChange={(e) => setBaseQuantity(e.target.value)}
          required
        />

        {/* Material Quantity */}
        <input
          type="number"
          step="0.01"
          className="w-full border p-2 rounded"
          placeholder="Material Quantity (e.g., 6 studs)"
          value={materialQuantity}
          onChange={(e) => setMaterialQuantity(e.target.value)}
          required
        />

        {/* Submit Button */}
        <button
          type="submit"
          className="w-full bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded transition"
        >
           Add Formula
        </button>

        {/* Message */}
        {message && <p className="text-sm text-center text-green-600">{message}</p>}
      </form>
    </div>
  );
};

export default AddFormula;
